import { v4 as uuidv4 } from 'uuid';

export interface FormInstallment {
  installmentId: string;
  installmentNumber: number;
  price: number;
}

// The one installment of a single-payment plan, priced at the plan total. The previous
// first installment is reused when there is one so its id survives an edit; when the
// count passed through 0 on the way to 1 there is none, and the installment must still be
// complete — the API rejects an installment without a number (ENG-2571).
export function createSingleInstallment(
  existing: FormInstallment | undefined,
  totalPrice: number,
): FormInstallment {
  return {
    installmentId: existing?.installmentId ?? uuidv4(),
    installmentNumber: 1,
    price: totalPrice,
  };
}
